import { render, staticRenderFns } from "./ProductAllComponent.vue?vue&type=template&id=47df1732&"
import script from "./ProductAllComponent.vue?vue&type=script&lang=js&"
export * from "./ProductAllComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductAllComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports